module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_22.56c3267c.webp";